import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/lib/content";

const ContentContext = createContext(DEFAULT_CONTENT);

export function ContentProvider({ children }) {
  const { data } = useQuery({
    queryKey: ["site-content"],
    queryFn: async () => (await api.get("/content")).data,
    staleTime: 60_000,
  });
  const content = { ...DEFAULT_CONTENT, ...(data || {}) };
  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export function useContent() {
  return useContext(ContentContext);
}
